// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GcpNatGateway } from './GcpNatGateway';
import {
  GcpNatGatewayFromJSON,
  GcpNatGatewayFromJSONTyped,
  GcpNatGatewayToJSON,
  GcpNatGatewayToJSONTyped,
} from './GcpNatGateway';

/**
 *
 * @export
 * @interface GcpNetwork
 */
export interface GcpNetwork {
  /**
   *
   * @type {GcpNatGateway}
   * @memberof GcpNetwork
   */
  natGateway?: GcpNatGateway;
  /**
   *
   * @type {number}
   * @memberof GcpNetwork
   */
  natIpCount?: number;
}

/**
 * Check if a given object implements the GcpNetwork interface.
 */
export function instanceOfGcpNetwork(value: object): value is GcpNetwork {
  return true;
}

export function GcpNetworkFromJSON(json: any): GcpNetwork {
  return GcpNetworkFromJSONTyped(json, false);
}

export function GcpNetworkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GcpNetwork {
  if (json == null) {
    return json;
  }
  return {
    natGateway:
      json['nat_gateway'] == null
        ? undefined
        : GcpNatGatewayFromJSON(json['nat_gateway']),
    natIpCount: json['nat_ip_count'] == null ? undefined : json['nat_ip_count'],
  };
}

export function GcpNetworkToJSON(json: any): GcpNetwork {
  return GcpNetworkToJSONTyped(json, false);
}

export function GcpNetworkToJSONTyped(
  value?: GcpNetwork | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    nat_gateway: GcpNatGatewayToJSON(value['natGateway']),
    nat_ip_count: value['natIpCount'],
  };
}
